module.exports = __webpack_public_path__ + "img/bankccb.2568ef37.gif";